import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

import BusinessProfileTimeline from 'components/payment-methods/business-profiles/timeline';
import Service from 'components/payment-methods/business-profiles/connect/service';

import env from 'lib/env';
import UserModel from 'models/user';

import linkBusinessProfilePendingCreator from 'action-creators/payment-methods/link-business-profile-pending';
import createBusinessProfileSuccessCreator from 'action-creators/payment-methods/create-business-profile-success';
import unlinkConcurCreator from 'action-creators/payment-methods/unlink-concur';
import linkExpensifyCreator from 'action-creators/payment-methods/link-expensify';
import unlinkExpensifyCreator from 'action-creators/payment-methods/unlink-expensify';
import trackEventCreator from 'action-creators/analytics/track-event';

import Brand from 'models/brand';
import AccountHeadline from 'components/common/account/account-headline';

const { CONCUR_APP_CENTER_LINK } = env();
const propTypes = {
  user: PropTypes.instanceOf(UserModel).isRequired,
  createBusinessProfileSuccess: PropTypes.func.isRequired,
  linkBusinessProfilePending: PropTypes.func.isRequired,
  unlinkConcur: PropTypes.func.isRequired,
  linkExpensify: PropTypes.func.isRequired,
  unlinkExpensify: PropTypes.func.isRequired,
  dismissPage: PropTypes.func.isRequired,
  timelineType: PropTypes.string,
  brand: PropTypes.instanceOf(Brand).isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  timelineType: 'edit',
};

class ConnectBusinessProfile extends Component {
  static renderDivider() {
    return (
      <div className="row">
        <div className="col-md-11 col-md-offset-1 padding-left-0-gte-md">
          <hr className="hidden-md basic-grey-divider" />
        </div>
      </div>
    );
  }

  constructor(props) {
    super(props);

    this.onConcurUnlink = this.onConcurUnlink.bind(this);
    this.onConcurLink = this.onConcurLink.bind(this);
    this.onExpensifyLink = this.onExpensifyLink.bind(this);
    this.onExpensifyUnlink = this.onExpensifyUnlink.bind(this);
    this.onSkipAndSaveProfile = this.onSkipAndSaveProfile.bind(this);
    this.dismissPage = this.dismissPage.bind(this);
  }

  componentDidMount() {
    require('smoothscroll-polyfill').polyfill();
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }

  onConcurLink() {
    this.props.linkBusinessProfilePending();
    this.props.dismissPage();
  }

  onConcurUnlink() {
    this.props.unlinkConcur();
    this.props.dismissPage();
  }

  onExpensifyLink() {
    this.props.linkExpensify();
    this.props.dismissPage();
  }

  onExpensifyUnlink() {
    this.props.unlinkExpensify();
    this.props.dismissPage();
  }

  onSkipAndSaveProfile() {
    this.props.createBusinessProfileSuccess();
    this.props.dismissPage();
  }

  dismissPage() {
    this.props.dismissPage();
  }

  render() {
    const { user, brand, app, trackEvent } = this.props;
    return (
      <div>
        <AccountHeadline brand={brand} headline="MANAGE PAYMENT METHODS" app={app} trackEvent={trackEvent} />
        <div className="row">
          <div className="heavy-shadowed area dismissable">
            <div className="dismiss-button clickable" onClick={this.dismissPage} />
            <div className="row">
              <div className="col-md-11 hidden-lte-sm">
                <BusinessProfileTimeline step={2} type={this.props.timelineType} />
                <hr className="hidden-md basic-grey-divider timeline-divider" />
                <h3 className="h3-sg text-color-dark-slate text-weight-medium numbered-header numbered-header-2">Expense Business Payments <span className="text-color-light-grey">Optional</span></h3>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-md-10 col-md-offset-1 padding-left-0-gte-md">
                <h3 className="h3-sg text-color-dark-slate text-weight-medium numbered-header numbered-header-2 visible-lte-sm">Expense Business Payments <span className="text-color-light-grey">Optional</span></h3>
              </div>
            </div>
            {ConnectBusinessProfile.renderDivider()}
            <Service
              serviceName="concur"
              user={user}
              onLink={this.onConcurLink}
              onUnlink={this.onConcurUnlink}
              serviceURL={CONCUR_APP_CENTER_LINK}
            />
            {ConnectBusinessProfile.renderDivider()}
            <Service
              serviceName="expensify"
              user={user}
              onLink={this.onExpensifyLink}
              onUnlink={this.onExpensifyUnlink}
            />
            {ConnectBusinessProfile.renderDivider()}
            <div className="row with-vertical-margin-2x">
              <div className="col-md-4 col-md-offset-1 col-xs-12">
                <a
                  className="btn btn-block btn-primary btn-md"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={this.onSkipAndSaveProfile}
                >
                  SAVE PROFILE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ConnectBusinessProfile.propTypes = propTypes;
ConnectBusinessProfile.defaultProps = defaultProps;

const dismissPage = () => push('/account/payment-methods/');

const mapStateToProps = (state) => {
  const {
    user,
  } = state.account;

  const { name: app } = state.app;

  return {
    user,
    app,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    linkBusinessProfilePending: linkBusinessProfilePendingCreator,
    createBusinessProfileSuccess: createBusinessProfileSuccessCreator,
    unlinkConcur: unlinkConcurCreator,
    linkExpensify: linkExpensifyCreator,
    unlinkExpensify: unlinkExpensifyCreator,
    dismissPage,
    trackEvent: trackEventCreator,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(ConnectBusinessProfile);
